import * as React from 'react';

import { TextField } from '../TextField';

interface IEmptyFieldProps {
  published?: boolean;
}

export const EmptyField: React.FC<IEmptyFieldProps> = ({ published }) => {
  return <TextField published={published}>—</TextField>;
};
